/* global dataLayer */

/**
 * Additional variables to be included in the data layer object that is passed
 * on to Google Tag Manager.
 *
 * Note: `dataLayer` gets defined to global scope in `head-datalayer.php`.
 */

if (dataLayer && 'function' === typeof dataLayer.push) {
  // Election Hub specific.
  document.addEventListener('ElectionHub', (event) => {
    if ('eHubClearFilter' === event.detail.eventType) {
      dataLayer.push({
        event: event.detail.eventType,
        'eHub.widgetName': event.detail.widgetTitle || '',
        'eHub.widgetId': event.detail.widgetId || '',
      });
    }

    if ('eHubApplyFilter' === event.detail.eventType) {
      dataLayer.push({
        event: event.detail.eventType,
        'eHub.widgetName': event.detail.widgetTitle || '',
        'eHub.widgetId': event.detail.widgetId || '',
        'eHub.filteredCard': event.detail.filteredCard || '',
      });
    }

    if ('eHubDisplay' === event.detail.eventType) {
      dataLayer.push({
        event: event.detail.eventType,
        'eHub.widgetName': event.detail.widgetTitle || '',
        'eHub.widgetId': event.detail.widgetId || '',
      });
    }
  });
}
